import React, {Component} from "react";
import {Modal, ModalHeader, ModalBody, ModalFooter, Button, Alert} from "reactstrap";
import {TextField, Typography} from "@material-ui/core";
import Framework from "@beardeddevops/react.framework";
import ObjectOverride from "../ObjectOverride";
import Types from "../../constants/Types";
import API from "@beardeddevops/react.api";
import APPCONFIG from "../../constants/Config";

/**
 * @property {Products_Object} state
 */
class ProductAddCsv extends ObjectOverride {
	constructor(props) {
		super(props, Types.Products._name);
		this.state = {
			csvInput: "",
			error: "",
			previewMode: false,
			firstProduct: null,
			productsArray: [],
			duplicateProducts: [],
			isDuplicateModalOpen: false,
			hasShownDuplicateModal: false,
			showRequiredAlert: false,
			iterator: 0,
			hasShownPreview: false,
			showPreviewAlert: false
		};
	}

	componentDidMount() {
		super.componentDidMount();
		if (typeof this.props.addAdditionalButtons === 'function') {
			this.props.addAdditionalButtons(<Button color="info" onClick={this.handlePreview}>Preview Products</Button>);
		}
	}

	handleInputChange = (event) => {
		this.setState({
			csvInput: event.target.value.replace(/\t/g, ','),
		});
	};

	// Validate CSV format
	handleCsvValidation = (csv) => {
		const fields = csv.split(",");
		const isValid = fields.length >= 6; // Expect at least 6 fields for each product
		return isValid;
	};


	// Handle form submission for preview
	handlePreview = () => {
		const {csvInput} = this.state;
		const rows = csvInput.split("\n");

		//TODO: pass the whole set and iterate through in the preview
		if (this.handleCsvValidation(rows[0])) {
			const firstProduct = rows[0].split(",");
			this.setState({
				previewMode: true,
				firstProduct,
				error: ""
			});
		} else {
			this.setState({
				error: "Invalid input. Ensure each row has at least 6 fields.",
			});
		}
	};

	async handleRequiredAlert() {
		this.setState({
			showRequiredAlert: false,
			showPreviewAlert: false
		});
	}

	// Final submission after preview
	async handleSubmit(event, suppressToast = false) {
		await this.handleRequiredAlert();
		if(!this.state.hasShownPreview) {
			this.setState({showPreviewAlert: true});
		}
		else {
			const {csvInput, hasShownDuplicateModal} = this.state;
			// this.setState({showRequiredAlert: false});
			const rows = csvInput.split("\n").map((row) => row.split(","));
			let foundRequiredError = false;
			if (rows[rows.length - 1].length <= 2 && rows[rows.length - 1][0] === "") {
				rows.pop();
			}
			for (let row of rows) {
				for (let i = 0; i < 6; i++) {
					if (i === 2) {
						continue;
					}
					if (row[i] === undefined || row[i] === null || row[i] === "") {
						foundRequiredError = true;
						this.setState({showRequiredAlert: true})
						break;
					}
				}
				if (foundRequiredError) {
					break;
				}
			}


			if (!foundRequiredError) {
				this.setState({
					productsArray: rows,
					csv_products_array: rows
				});

				let csvModel = new API.BuildClass(Types.Products._name, 'PUT_CSV_DUMP')
				csvModel.object.csv_products_array = rows;
				let myProducts = await csvModel.submit(null, 'PUT_CSV_DUMP');

				const {products, duplicate_products} = myProducts;

				if (duplicate_products?.length > 0 && !hasShownDuplicateModal) {
					// Show duplicate modal if duplicates exist and it hasn't been shown yet
					this.setState({
						duplicateProducts: duplicate_products,
						nonDupProducts: products,
						isDuplicateModalOpen: true,
						hasShownDuplicateModal: true
					});
				} else {

					this.props.afterSave(myProducts);
				}
			}
		}


	};


	// Close the duplicate modal
	handleCloseDuplicateModal = () => {
		this.setState({isDuplicateModalOpen: false});
		this.props.afterSave(this.state.nonDupProducts);
	};

	// Handle canceling preview and returning to edit mode
	handleCancelPreview = () => {
		this.setState({
			iterator: 0,
			previewMode: false,
			firstProduct: null
		});
	};

	// Render duplicate modal
// Render duplicate modal
	// Render duplicate modal
	renderDuplicateModal = () => {
		const {duplicateProducts, isDuplicateModalOpen} = this.state;
		return (
			<div>
				{this.state.showRequiredAlert && <Alert color="danger">
					Error: Please check your entries, one or more of your products are missing the required fields: type, manufacturer, importer,
					model, caliber, serial.
				</Alert>}
				{this.state.showPreviewAlert && <Alert color="danger">
					Error: Please double check the first product by clicking preview products before continuing.
				</Alert>}
				<Modal isOpen={isDuplicateModalOpen} toggle={this.handleCloseDuplicateModal}>
					<ModalHeader toggle={this.handleCloseDuplicateModal}>
						Duplicate Products Found
					</ModalHeader>
					<ModalBody>
						<Typography variant="h6">The following products already exist:</Typography>
						<ul>
							{duplicateProducts.map((product, index) => (
								<li key={index}>
									<strong>Serial:</strong> {product.serial || "N/A"}{" "}
									<strong>SKU:</strong> {product.sku || "N/A"}
								</li>
							))}
						</ul>
					</ModalBody>
					<ModalFooter>
						<Button color="primary" onClick={this.handleCloseDuplicateModal}>
							Close
						</Button>
					</ModalFooter>
				</Modal>
			</div>
		);
	};




	renderPreview = () => {
		// const {firstProduct} = this.state;
		// if (!firstProduct) return null;
		// this.setState({
		// 	hasShownPreview: true,
		// 	showPreviewAlert: false
		// });
		const {csvInput} = this.state;
		if (!csvInput) return null;
		const rows = csvInput.split("\n");

		const [type, manufacturer, importer, model, caliber, serial, sku, barrelLength, overallLength, cost, minSalesPrice, listPrice, semiAuto, magCapacity, used] = rows[this.state.iterator].split(",");

		this.state.hasShownPreview = true;
		this.state.showPreviewAlert = false;
		return (
			<div className={"row"}>
				<div className={"col-1 d-flex align-items-center"}>
					{this.state.iterator > 0 &&
						<Button color="secondary" onClick={() => this.setState({iterator: this.state.iterator - 1})}>
							View Previous
						</Button>
					}
				</div>
				{/*TODO: make this look a lil nicer, probly more center*/}
				<div className={"col-10"}>
						<Typography className={"d-flex justify-content-center"} variant="h6">Preview of Product #{this.state.iterator + 1}'s Values:</Typography>
						<div className={'form-group'}>
							<div className={"row"}>
								<Typography className={"col-4"}>Type: {type}</Typography>
								<Typography className={"col-4"}>Manufacturer: {manufacturer}</Typography>
								<Typography className={"col-4"}>Importer: {importer}</Typography>
							</div>
						</div>
						<div className={"form-group"}>
							<div className={"row"}>
							<Typography className={"col-4"}>Model: {model}</Typography>
							<Typography className={"col-4"}>Caliber: {caliber}</Typography>
							<Typography className={"col-4"}>Serial: {serial}</Typography>
							</div>
						</div>
						<div className={"form-group"}>
							<div className={"row d-flex"}>
								<Typography className={"col-4"}>SKU: {sku}</Typography>
								<Typography className={"col-4"}>Barrel Length: {barrelLength}</Typography>
								<Typography className={"col-4"}>Overall Length: {overallLength}</Typography>
							</div>
						</div>
						<div className={"form-group"}>
							<div className={"row d-flex"}>
								<Typography className={"col-4"}>Cost: {cost}</Typography>
								<Typography className={"col-4"}>Min Sales Price: {minSalesPrice}</Typography>
								<Typography className={"col-4"}>List Price: {listPrice}</Typography>
							</div>
						</div>
						<div className={"form-group"}>
							<div className={"row d-flex"}>
								<Typography className={"col-4"}>Semi-Automatic: {semiAuto}</Typography>
								<Typography className={"col-4"}>Magazine Capacity: {magCapacity}</Typography>
								<Typography className={"col-4"}>Used: {used}</Typography>
							</div>
						</div>
						<Button className={"d-flex mx-auto"} color="secondary" onClick={this.handleCancelPreview}>
							Back to Edit
						</Button>
				</div>
				{/*TODO: make this not crash if going beyond input*/}
				<div className={"col-1 d-flex align-items-center"}>
					{this.state.iterator + 1 < rows.length &&
						<Button color="secondary" onClick={() => this.setState({iterator: this.state.iterator + 1})}>
							View Next
						</Button>
					}
				</div>
			</div>
		);
	};

	render() {
		const {csvInput, error, previewMode} = this.state;

		return (
			<div>
				{/*<Typography variant="h5">Add Bulk Products from CSV</Typography>*/}

				{previewMode ? (
					this.renderPreview()
				) : (
					<div>
						<div style={{marginTop: '8px', padding: '8px', backgroundColor: '#f9f9f9', borderRadius: '4px'}}>
							<Typography variant="subtitle1">Required Fields:</Typography>
							<div style={{
								display: 'flex',
								flexWrap: 'wrap',
								gap: '16px',
								marginBottom: '16px',
								borderBottom: '1px solid #ccc',
								paddingBottom: '8px'
							}}>
								{['Type', 'Manufacturer', 'Importer', 'Model', 'Caliber', 'Serial'].map((field, index) => (
									<div key={index} style={{
										display: 'flex',
										alignItems: 'center',
										paddingRight: '16px',
										borderRight: index < 5 ? '1px solid #ccc' : 'none' // No border for last item
									}}>
										<Typography>{field}</Typography>
									</div>
								))}
							</div>

							<Typography variant="subtitle1">Optional Fields:</Typography>
							<div style={{
								display: 'flex',
								flexWrap: 'wrap',
								gap: '16px'
							}}>
								{['SKU', 'Barrel Length', 'Overall Length', 'Cost', 'Min Sales Price', 'List Price', 'Semi-Automatic', 'Magazine Capacity', 'Used'].map((field, index) => (
									<div key={index} style={{
										display: 'flex',
										alignItems: 'center',
										paddingRight: '16px',
										borderRight: index < 8 ? '1px solid #ccc' : 'none' // No border for last item
									}}>
										<Typography>{field}</Typography>
									</div>
								))}
							</div>
						</div>
						<br/>

						<TextField
							label="Input"
							multiline
							fullWidth
							rows={6}
							value={csvInput}
							onChange={this.handleInputChange}
							variant="outlined"
							placeholder="type,manufacturer,importer,model,caliber,serial,sku,barrel length,overall length,cost,min sales price,list price,semi-auto,mag capacity,used"
						/>
						<span>
							Copy your data from the <a
							href={`${APPCONFIG.settings.apiURL()}/${APPCONFIG.settings.apiVersion}/filesizes/file_download`}>Helper Spreadsheet</a> or
							type each product on a new line in the input box, with fields separated by commas. Please review the <a
							href={`${APPCONFIG.settings.apiURL()}/${APPCONFIG.settings.apiVersion}/filesizes/file_download`}>Helper
							Spreadsheet</a> for FAQs and how to use the Bulk Product Acquisition.
						</span>
						<br/>
						[<a href={`${APPCONFIG.settings.apiURL()}/${APPCONFIG.settings.apiVersion}/filesizes/file_download`}> Download Helper
							Spreadsheet</a>]
						{error && <Typography style={{color: "red"}}>{error}</Typography>}

					</div>
				)}

				{/* Render the duplicate modal */}
				{this.renderDuplicateModal()}
			</div>
		);
	}
}

export default Framework.Components.withRootState(ProductAddCsv);
